<button
  type="button"
  class="figures"
  (click)="setTooltip(!tooltip)"
  [disabled]="isOffline || isZoomed"
  [class.cursorDefault]="isOffline"
>
  <txtb-icons
    type="figures"
    [fill]="isOffline || isZoomed ? disabledColor : tooltip ? activeColor : null"
  ></txtb-icons>
</button>
<ul class="tooltip" *ngIf="tooltip && !isOffline && !isZoomed">
  <li class="figures-option rectangle" (click)="sendTool(toolNames.Rectangle)">
    <txtb-icons
      type="rectangle"
      [stroke]="(pickedTool$ | async) === toolNames.Rectangle ? activeColor : null"
    ></txtb-icons>
  </li>
  <li class="figures-option circle" (click)="sendTool(toolNames.Circle)">
    <txtb-icons
      type="circle"
      [stroke]="(pickedTool$ | async) === toolNames.Circle ? activeColor : null"
    ></txtb-icons>
  </li>
  <li class="figures-option polygon1" (click)="sendTool(toolNames.IsoscelesTriangle)">
    <txtb-icons
      type="polygon1"
      [fill]="(pickedTool$ | async) === toolNames.IsoscelesTriangle ? activeColor : null"
    ></txtb-icons>
  </li>
  <li class="figures-option polygon2" (click)="sendTool(toolNames.RectangularTriangle)">
    <txtb-icons
      type="polygon2"
      [stroke]="(pickedTool$ | async) === toolNames.RectangularTriangle ? activeColor : null"
    ></txtb-icons>
  </li>
  <li class="figures-option line" (click)="sendTool(toolNames.Line)">
    <txtb-icons
      type="line"
      [stroke]="(pickedTool$ | async) === toolNames.Line ? activeColor : null"
    ></txtb-icons>
  </li>
</ul>
